<template>
  <img
    :id="id"
    :class="imageClass"
    :src="__src"
    :alt="alt"
    draggable="false"
    @error.once="setFallbackImg"
    @dragstart.prevent
  />
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  id: {
    type: String,
    default: '',
  },
  src: {
    type: String,
    default: '',
  },
  alt: {
    type: String,
    default: '',
  },
  fallbackSrc: {
    type: String,
    default: '',
  },
  imageClass: {
    type: [Object, Array, String],
    default: '',
  },
});

const __src = computed(() => props.src || props.fallbackSrc);

const setFallbackImg = (event) => {
  if (props.fallbackSrc && !event.target.src.includes(props.fallbackSrc)) {
    event.target.src = props.fallbackSrc;
  }
};
</script>
